import { Box, Button, Grid, Hidden, Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next';
import PublicPage from '../PublicPage';
import { BackIcon } from '../../components/IconComponent';
import { config_path, portalCfg } from '../../router/config.path';
import { useNavigate } from 'react-router-dom';
import Modal from '../../components/Modal';
import InitiatePage from '../InitiatePage';

export default function LoginRegisterView(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { palette } = useTheme();  
    const { showContinueAsGuest } = props;

    const renderContent = () => {
        return (
            <>
            <Box
                sx={{
                    position: 'absolute',
                    bottom: '0px',
                    backgroundColor: palette.background.paper,
                    borderRadius: '20px 20px 0px 0px',
                    p: 3, 
                    width: { xs: '100%', md: '90%' },
                }}>
                <Grid item xs={12} container alignItems={'center'} justifyContent={'flex-start'} mt={2}>
                    <Button size='large' id='loginRegister/btnLogin' sx={{borderRadius:'30px'}} fullWidth variant='contained' onClick={() => props.onLogin()}>{t('btn_login')}</Button>
                </Grid>

                <Grid item xs={12} container alignItems={'center'} justifyContent={'flex-start'} mt={2} mb={2}>
                    <Button size='large' id='loginRegister/btnRegister' sx={{borderRadius:'30px'}} fullWidth variant='outlined' onClick={() => props.onRegister()}>{t('btn_register')}</Button>
                </Grid>

                {showContinueAsGuest && 
                    <Grid item xs={12} container alignItems={'center'} justifyContent={'flex-start'} mb={1}>
                        <Button size='large' id='loginRegister/btnRegister' sx={{borderRadius:'30px'}} fullWidth onClick={() => props.onLoginGuest()}>{t('btn_guest_login')}</Button>
                    </Grid>
                }

                <Box>
                    <center><img src={portalCfg.publicPath + '/assets/images/transparent_crm_logo.png'} alt='Logo CRM' height={50} /></center>
                </Box>
            </Box>
            
            {props.showRegisterAction && <Modal
                isOpen={props.showRegisterAction}
                onClose={() => props.setShowRegisterAction(false)}
                enableCloseButton
                title={t('btn_register')}
                width={{xs:"100%",md:"unset"}}
                height={{xs:"100vh",md:"unset"}}
                bottom={{xs:0,md:"unset"}}
                isHeader={true}
                borderRadius={{xs:0,md:"4px"}}
            >   
                <Hidden mdUp>
                    <Stack onClick={() => props.setShowRegisterAction(false)} direction={'row'} marginLeft={-2}   mb={3}>
                        <Stack style={{ cursor: 'pointer' }} >
                            <BackIcon />
                        </Stack>
                    </Stack>
                </Hidden>
                <Box>
                    <Stack direction={'row'}>
                        <Typography fontWeight={{xs:"bold",md:"unset"}} variant='caption' textAlign={'center'}>{t('exits_rewards_participant')}</Typography>
                    </Stack>
                    <Stack marginTop={4} direction={'row'} justifyContent={'center'} gap={2} alignItems={'center'}>
                        <Stack flex={1} justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <img src={portalCfg.publicPath + '/assets/images/register_have_card.png'} alt={'Logo Image'} height={150} />
                            <Button id='loginEmail/btnRegisterHaveCard' sx={{width:{xs:"100%",md:"unset"}, borderRadius:'30px'}} onClick={() => navigate(config_path.register_existing_customer)} variant='outlined'>{t('btn_register_have_card')}</Button>
                        </Stack>
                        <Stack flex={1} justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <img src={portalCfg.publicPath + '/assets/images/register_new.png'} alt={'Logo Image'} height={150} />
                            <Button id='loginEmail/btnRegisterNew' sx={{width:{xs:"100%",md:"unset"}, borderRadius:'30px'}} onClick={() => navigate(config_path.register)} variant='contained'>{t('btn_register_new')}</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>}
       </> )
    }

    return (
        <>
            <Hidden mdUp>
                <InitiatePage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage showMore>
                    {renderContent()}
                </InitiatePage>
            </Hidden>

            <Hidden mdDown>
                <PublicPage message={props.message} showProcessing={props.showProcessing} confirm={props.confirm} showLanguage useConfiguredLanguage showMore>
                    {renderContent()}
                </PublicPage>
            </Hidden>
        </>
        
    )
}
